"use client";
import SvgAudiSymbol from "./audi_symbol.svg.js";
import SvgAudiWordmark from "./audi_wordmark.svg.js";
const audi = {
  key: "audi",
  symbol: SvgAudiSymbol,
  wordmark: SvgAudiWordmark
};
export {
  audi
};
